import { memo } from "react";

import { Box, Checkbox, Typography } from "@material-ui/core";

import themeColorsDesingSystem from "assets/theme/ds-colors";

import { formatRepresentativeLabel } from "../utils/representative-helpers";

function RepresentativeCard({ item, checked, onChange, disabled }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      py={1}
      px={1}
      style={{
        borderBottom: `1px solid ${themeColorsDesingSystem.stone.light}`,
      }}
    >
      <Checkbox
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        color="primary"
        size="small"
      />
      <Typography
        variant="body2"
        style={{
          margin: 0,
          color: themeColorsDesingSystem.text.primary,
          fontSize: "0.875rem",
          lineHeight: 1.4,
        }}
      >
        {formatRepresentativeLabel(item)}
      </Typography>
    </Box>
  );
}

export default memo(RepresentativeCard);
